export default "__VITE_ASSET__B2kOHO2m__"